import {createSelector} from 'reselect';
import {AppState} from '../../../store';

export const commonSelector = (state: AppState) => state.BusCommonSEO;

export const commonDOJSelector = createSelector(commonSelector, item => {
  return item.doj;
});
  
  export const journeyTypeSelector = createSelector(commonSelector, item => {
    return item.journeyType;
  });
    
  
